import React from 'react'
import { Card, CardHeader, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { PropertyList } from '../../../../../components/PropertyList'
import CircularLoading from '../../../../../components/CircularProgress'
import { IMerchant } from '../../../../../types/merchant'

interface FilterGroupProps {
  isLoading: boolean
  merchant?: IMerchant
  updateMerchant?: (data: Partial<IMerchant>) => void
}

const menuItemsBankType = [
  {
    code: '002',
    bank: 'ธนาคารกรุงเทพ',
    symbol: 'BBL',
  },
  {
    code: '004',
    bank: 'ธนาคารกสิกรไทย',
    symbol: 'KBANK',
  },
  {
    code: '006',
    bank: 'ธนาคารกรุงไทย',
    symbol: 'KTB',
  },
  {
    code: '011',
    bank: 'ธนาคารทหารไทย',
    symbol: 'TMB',
  },
  {
    code: '014',
    bank: 'ธนาคารไทยพาณิชย์',
    symbol: 'SCB',
  },
  {
    code: '017',
    bank: 'ธนาคารซิตี้แบงค์',
    symbol: 'CITI',
  },
  {
    code: '020',
    bank: 'ธนาคารกรุงศรีอยุธยา',
    symbol: 'BAY',
  },
  {
    code: '022',
    bank: 'ธนาคารยูโอบี',
    symbol: 'UOB',
  },
  {
    code: '801',
    bank: 'ธนาคารแห่งประเทศจีน',
    symbol: 'BOC',
  },
  {
    code: '065',
    bank: 'ธนาคารธนชาต (Tbank)',
    symbol: 'TBank',
  },
  {
    code: '066',
    bank: 'ธนาคารธนชาต (TCAP)',
    symbol: 'TCAP',
  },
  {
    code: '070',
    bank: 'ธนาคารไอซีบีซี (ไทย)',
    symbol: 'ICBKTHBK',
  },
]


const MerchantSetUpBankAccountCard = ({ isLoading, merchant, updateMerchant }: FilterGroupProps) => {
  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Card
        sx={{
          padding: 2,
        }}>
        <CardHeader title="ตั้งค่าบัญชีธนาคาร (ขนส่ง bestexpress)" />
        <Divider />
        <PropertyList>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <TextField
                required
                id="account"
                fullWidth
                label="ชื่อบัญชี"
                name="account"
                defaultValue={merchant?.config.bank?.account}
                onChange={(e) => updateMerchant?.({
                  config: {
                    ...merchant?.config,
                    bank: {
                      ...merchant?.config.bank,
                      account: e.target.value,
                    },
                  },
                })}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <TextField
                required
                id="number"
                fullWidth
                label="เลขที่บัญชี"
                name="number"
                defaultValue={merchant?.config.bank?.number}
                onChange={(e) => updateMerchant?.({
                  config: {
                    ...merchant?.config,
                    bank: {
                      ...merchant?.config.bank,
                      number: e.target.value,
                    },
                  },
                })}
              />
            </Grid>
            <Grid item xs={12} lg={12}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="name-label">ชื่อธนาคาร</InputLabel>
                <Select
                  id="name"
                  name="name"
                  labelId="name-label"
                  value={merchant?.config.bank?.code}
                  onChange={(e) => {
                    const bank = menuItemsBankType.find((item) => item.code === e.target.value)
                    updateMerchant?.({
                      config: {
                        ...merchant?.config,
                        bank: {
                          ...merchant?.config.bank,
                          code: bank?.code,
                          name: bank?.bank,
                        },
                      },
                    })
                  }}
                  fullWidth
                >
                  {
                    menuItemsBankType.map((item) => (
                      <MenuItem value={item.code} key={item.code}>
                        {item.bank}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </PropertyList>
      </Card>
    </>
  )
}

export default MerchantSetUpBankAccountCard
